import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import React, {useEffect, useState} from "react";
import RaikoNumberInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoNumberInputOutlined";
import {convertToMobileNumber} from "../../util/numberConvertor";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import RaikoCustomSelect, {
    raikoCustomSelectItemGenerator
} from "../../raikoComponents/raikoCustomSelect/RaikoCustomSelect";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {ContactUsService} from "../../serverService/contactUsService/ContactUsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import RaikoGridThreeColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridThreeColumn";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import {RaikoDivider} from "../../raikoComponents/raikoDivider/RaikoDivider";

const ShowThisMessage = ({id}) => {

    const service = new ContactUsService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            getDataFromServer()
        }
    }, [id]);

    function getDataFromServer() {
        loading.show()
        service.getMessageDetail(id)
            .then(response => {
                setSubject(response.title)
                setFullName(`${response.firstName} ${response.lastName}`)
                setMessage(response.description)
                setEmail(response.email)
                setPhoneNumber(response.phoneNumber)
                setCreatedAt(convertUniversalDateToPersianDate(response.sendAt))

                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات پیام."))
            loading.hide()
        })
    }


    const [subject, setSubject] = useState("")
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [message, setMessage] = useState("")
    const [createdAt, setCreatedAt] = useState("");

    const [messageStatus, setMessageStatus] = useState(MESSAGE_STATUS.PENDING.id)


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>

            <RaikoGridThreeColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"موضوع"}
                    value={subject}
                    disabled={true}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"نام و نام خانوادگی"}
                    value={fullName}
                    disabled={true}
                />
                <RaikoSimpleInputOutlined
                    labelText={"تاریخ ارسال"}
                    value={createdAt}
                    setValue={setCreatedAt}
                    disabled={true}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"ایمیل"}
                    value={email}
                    disabled={true}
                />

                <RaikoMaterialOutlinedInput
                    placeHolder={"091..."}
                    labelText={"شماره همراه"}
                    className={css`direction: ltr;
                      text-align: end;`}
                    disabled={true}
                    value={convertToMobileNumber(phoneNumber)}
                    onChange={({target}) => {
                        const _phoneNumber = convertToMobileNumber(target.value)
                        setPhoneNumber(_phoneNumber.replaceAll(" ", ""))
                    }}/>
            </RaikoGridThreeColumn>
            <RaikoGridOneColumn>
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"متن پیام"}
                    setValue={setMessage}
                    disabled={true}
                    value={message}/>
            </RaikoGridOneColumn>

            <RaikoDivider/>

            <RaikoCustomSelect
                labelText={"وضعیت بررسی"}
                setValue={setMessageStatus}
                items={[
                    raikoCustomSelectItemGenerator(MESSAGE_STATUS.PENDING.id, MESSAGE_STATUS.PENDING.title),
                    raikoCustomSelectItemGenerator(MESSAGE_STATUS.REVIEWED.id, MESSAGE_STATUS.REVIEWED.title),
                ]}
                value={messageStatus}
            />

            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"بروزرسانی"}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}
export default ShowThisMessage;
const MESSAGE_STATUS = {
    PENDING: {
        id: "PENDING",
        title: "در حال بررسی"
    },
    REVIEWED: {
        id: "REVIEWED",
        title: "بررسی شده"
    }
}